import { ActionType, ComponentType } from '../../enums';

export interface CreateMenuClickEventPayloadOptions {
  itemText: string;
  url: string;
}

export interface CreateMenuClickEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    item_text: string;
    url: string;
  };
}

export const createMenuClickEventPayload = ({ itemText, url }: CreateMenuClickEventPayloadOptions): CreateMenuClickEventPayloadReturn => ({
  event_data: {
    action: ActionType.CLICK,
    component_type: ComponentType.MENU,
    item_text: itemText,
    url,
  },
});
